import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FloatingActionButtonExtendedSize from './FloatingActionButtonExtendedSize';
import ClientProvider from './client';
export default createDemo(import.meta.url, FloatingActionButtonExtendedSize, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/floating-action-button/demos/extended-size/FloatingActionButtonExtendedSize.tsx",
    "fileName": "FloatingActionButtonExtendedSize.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport Fab from '@mui/material/Fab';\nimport NavigationIcon from '@mui/icons-material/Navigation';\n\nexport default function FloatingActionButtonExtendedSize() {\n  return (\n    <Box sx={{ '& > :not(style)': { m: 1 } }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Fab variant=\"extended\" size=\"small\" color=\"primary\">\n        <NavigationIcon sx={{ mr: 1 }} />\n        Extended\n      </Fab>\n      <Fab variant=\"extended\" size=\"medium\" color=\"primary\">\n        <NavigationIcon sx={{ mr: 1 }} />\n        Extended\n      </Fab>\n      <Fab variant=\"extended\" color=\"primary\">\n        <NavigationIcon sx={{ mr: 1 }} />\n        Extended\n      </Fab>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 22,
        "focusedLines": 12,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport Fab from '@mui/material/Fab';\nimport NavigationIcon from '@mui/icons-material/Navigation';\n\nexport default function FloatingActionButtonExtendedSize() {\n  return (\n    <Box sx={{ '& > :not(style)': { m: 1 } }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Fab variant=\"extended\" size=\"small\" color=\"primary\">\n        <NavigationIcon sx={{ mr: 1 }} />\n        Extended\n      </Fab>\n      <Fab variant=\"extended\" size=\"medium\" color=\"primary\">\n        <NavigationIcon sx={{ mr: 1 }} />\n        Extended\n      </Fab>\n      <Fab variant=\"extended\" color=\"primary\">\n        <NavigationIcon sx={{ mr: 1 }} />\n        Extended\n      </Fab>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Fab"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "extended",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "small",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "primary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "NavigationIcon"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "mr"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            "        Extended"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Fab"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Fab"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "extended",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "medium",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "primary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "NavigationIcon"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "mr"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            "        Extended"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Fab"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Fab"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "extended",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "primary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "NavigationIcon"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "mr"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            "        Extended"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Fab"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 22,
    "focusedLines": 12,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/Fab",
      "@mui/icons-material/Navigation"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
